import api from "./Api";

class RestauranteAuditoriaService {
  GetRestauranteAuditoria(payload) {
    return api.get("/v1/restauranteauditoria/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRestauranteAuditoria(payload) {
    return api.post("/v1/restauranteauditoria/", payload).then((response) => {
      return response.data;
    });
  }

  PutRestauranteAuditoria(payload) {
    return api.put("/v1/restauranteauditoria/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRestauranteAuditoria(payload) {
    return api
      .delete("/v1/restauranteauditoria/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRestauranteAuditoriaOData(payload) {
    return api.get("/OData/RestauranteAuditoria" + payload).then((response) => {
      return response.data;
    });
  }

  GetRestauranteAuditoriaPesquisa(payload) {
    return api
      .get("/v1/restaurante/auditoria/pesquisa" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostRegistrarRestauranteAuditoria(payload) {
    return api
      .post("/v1/restaurante/auditoria/registrar", payload)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return null;
      });
  }

  PostRegistrarRestauranteLog(payload) {
    return api
      .post("/v1/restaurante/auditoria/registrar", {
        ...payload,
        log: true,
      })
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return null;
      });
  }
}

export default new RestauranteAuditoriaService();
